import { useSearchParams } from 'next/navigation';
import useClientAccountProfileQuery from '../../queries/useClientAccountProfileQuery';

export const USERID_QUERY_KEY = 'userId';
export const OLD_USERID_QUERY_KEY = 'user_id';

export default function useUserId() {
  const { data } = useClientAccountProfileQuery();
  const searchParams = useSearchParams();

  const isAdmin = !!data?.isAdmin;
  const sessionUserId = data?.id || null;
  const newQueryUserId = searchParams.get(USERID_QUERY_KEY)
    ? Number(searchParams.get(USERID_QUERY_KEY))
    : null;
  const oldQueryUserId = searchParams.get(OLD_USERID_QUERY_KEY)
    ? Number(searchParams.get(OLD_USERID_QUERY_KEY))
    : null;

  const queryUserId = newQueryUserId || oldQueryUserId;

  return {
    queryUserId,
    sessionUserId,
    targetUserId: isAdmin && queryUserId ? queryUserId : sessionUserId,
  };
}
